import { render, staticRenderFns } from "./BiddingAmountHeader.vue?vue&type=template&id=0700c0ae&scoped=true&"
import script from "./BiddingAmountHeader.vue?vue&type=script&lang=js&"
export * from "./BiddingAmountHeader.vue?vue&type=script&lang=js&"
import style0 from "./BiddingAmountHeader.vue?vue&type=style&index=0&id=0700c0ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0700c0ae",
  null
  
)

export default component.exports